export const getTimezoneOffsetInMinutes = (): number => new Date().getTimezoneOffset();

export const getTimezoneOffsetInSeconds = (): number => getTimezoneOffsetInMinutes() * 60;